import { DEFAULT_LOCALE, SUPPORTED_LOCALE_LIST,type SupportedLocale } from "@ark/shared";

interface ResolveLocaleInput {
  userLocale: string | null | undefined;
  workspaceLocale: string | null | undefined;
}

export function resolveLocale({ userLocale, workspaceLocale }: ResolveLocaleInput): SupportedLocale {
  if (userLocale && SUPPORTED_LOCALE_LIST.includes(userLocale as SupportedLocale)) {
    return userLocale as SupportedLocale;
  }

  if (workspaceLocale && SUPPORTED_LOCALE_LIST.includes(workspaceLocale as SupportedLocale)) {
    return workspaceLocale as SupportedLocale;
  }

  return DEFAULT_LOCALE;
}
